import WriteBatch from '../components/WriteBatch';
import SelectionEdit from '../components/SelectionEdit';

const sampleTemplateMixin = {
  components: { WriteBatch, SelectionEdit },
  props: {},
  data() {
    return {
      writeSampleList: [],
      tableSelection: [],
      // 批量编辑样品属性
      batchEditVisible: false,
      editTitle: '',
      editPropetyArray: [],
      editFormType: 'input',
      editFormOptions: [],
      // 批量设置 检验日期、设备、温度、湿度等
      batchSelectVisible: false,
      // 处理样品太多，系统卡顿的问题
      focusCell: '',
      focusDebounce: null
    };
  },
  computed: {},
  methods: {
    handleSelectionChange(val) {
      this.tableSelection = val;
    },

    handletSampleAdd() {
      this.batchSelectVisible = true;
    },
    handleSelectionChange(val) {
      this.tableSelection = val;
    },
    // 处理样品太多，系统卡顿问题 聚焦单元格
    updateFocusCell(updateValue) {
      if (!this.focusDebounce) {
        // 第一次调用时立即执行聚焦操作
        this.focusCell = updateValue;
        this.$nextTick(() => {
          const element = document.getElementById(updateValue);
          if (element) {
            element.focus();
          } else {
            console.warn(`Element with id ${updateValue} not found`);
          }
        });
      }

      // 重置防抖计时器
      clearTimeout(this.focusDebounce);
      this.focusDebounce = setTimeout(() => {
        this.focusDebounce = null;
      }, 50); // 50ms 的防抖时间
    },
    /******** 批量编辑 Start ********/
    // 打开弹窗
    handleBatchEdit(...batchParams) {
      if (!this.tableSelection.length) return this.$message.warning('请选择要批量编辑的数据!');

      const editTitle = batchParams.shift();
      const editPropetyArray = [...batchParams]; // 选择修改的属性

      this.editFormType = 'input';
      this.editTitle = editTitle;
      this.editPropetyArray = editPropetyArray;
      this.batchEditVisible = true;
    },
    // 打开弹窗radio
    handleBatchEditRadio(...batchParams) {
      if (!this.tableSelection.length) return this.$message.warning('请选择要批量编辑的数据!');

      const editTitle = batchParams.shift();
      const radioOptions = batchParams.shift();
      const editPropetyArray = [...batchParams]; // 选择修改的属性

      this.editFormType = 'radio';
      this.editFormOptions = radioOptions;
      this.editTitle = editTitle;
      this.editPropetyArray = editPropetyArray;
      this.batchEditVisible = true;
    },
    // 批量编辑弹窗回调
    emitBatchEdit(editPropetyArray, editType, editValue, replaceSourceStr) {
      this.writeSampleList.forEach(item => {
        if (this.tableSelection.some(selItem => selItem.id == item.id)) {
          //  修改选中行的数据
          let obj = item;
          for (let i = 0; i < editPropetyArray.length - 1; i++) {
            obj = obj[editPropetyArray[i]];
          }

          const oldValue = obj[editPropetyArray[editPropetyArray.length - 1]];
          let newValue = editValue;
          if (editType === 2) {
            // 头部添加
            newValue = editValue.concat(oldValue);
          }
          if (editType === 3) {
            // 尾部添加
            newValue = oldValue.concat(editValue);
          }
          if (editType === 4) {
            // 替换
            const regex = new RegExp(`${replaceSourceStr}`, 'g');
            newValue = oldValue.replace(regex, editValue);
          }

          obj[editPropetyArray[editPropetyArray.length - 1]] = newValue;
        }
      });
    }
    /******** 批量编辑 End ********/
  }
};

export default sampleTemplateMixin;
